import { OAUTH_CALLBACK_ROUTE_PATHS } from "~/utils/oauth-callback-route";

export const SKIP_LOGOUT_REDIRECT_ONCE_KEY = "skipLogoutRedirectOnce";

export const shouldSkipLogoutRedirect = ({
  path,
  storage,
}: {
  path: string;
  storage: Pick<Storage, "getItem" | "removeItem">;
}) => {
  const shouldSkipLogoutRedirect =
    storage.getItem(SKIP_LOGOUT_REDIRECT_ONCE_KEY) === "true";
  const isOAuthCallbackRoute = OAUTH_CALLBACK_ROUTE_PATHS.includes(path);

  if (shouldSkipLogoutRedirect || isOAuthCallbackRoute) {
    storage.removeItem(SKIP_LOGOUT_REDIRECT_ONCE_KEY);

    return {
      skip: true,
      isOAuthCallbackRoute,
      shouldSkipLogoutRedirect,
    };
  }

  return {
    skip: false,
    isOAuthCallbackRoute,
    shouldSkipLogoutRedirect,
  };
};
